module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'coupon') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择优惠券"
    }
  }, [_c('draggable', {
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.data),
      callback: function($$v) {
        _vm.data = $$v
      },
      expression: "data"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setting-item item-selected"
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "banner-uploader square thumbnail",
      attrs: {
        "src": _vm.wximageurl + item.imgUrl
      },
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }) : _c('div', {
      staticClass: "banner-uploader square thumbnail",
      on: {
        "click": function($event) {
          return _vm.handleImgChange(index)
        }
      }
    }, [_c('div', {
      staticClass: "content-center"
    }, [_c('i', {
      staticClass: "iconfont icon-camera"
    })])]), _vm._v("\n          " + _vm._s(item.title) + "\n          "), (item.type === 'cash') ? _c('span', {
      staticClass: "amount-cur"
    }, [_vm._v(_vm._s(item.amount) + "元满减券")]) : _vm._e(), _vm._v(" "), (item.type === 'discount') ? _c('span', {
      staticClass: "amount-cur"
    }, [_vm._v(_vm._s(item.amount) + "折券")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "setting-remove",
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt"
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M （建议尺寸：375px * 200px）")]), _vm._v(" "), _c('el-button', {
    staticClass: "iconfont icon-cog banner-button-uploader",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.setCoupons
    }
  }, [_vm._v(" 设置优惠券")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dea8fdb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dea8fdb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/coupon.vue
// module id = 2947
// module chunks = 0